interface Config {
  apiBaseUrl: string;
  agentApiBaseUrl: string;
  agentIframeBaseUrl: string;
  micrositesOrigin: string;
  spendbrainClientId: string;
  spendbrainTenantId: string;
  spendbrainSentryDSN: string;
  spendbrainEnv: 'prod' | 'staging' | 'dev' | 'local';
  extensionClientId: string;
  extensionTenantId: string;
  extensionEnv: 'prod' | 'staging' | 'dev' | 'local';
  extensionSentryDSN: string;
  extensionGTMId: string;
  extensionSecretToken: string;
  extensionSpendbrainRedirectUrl: string;
  isExtension: boolean;
  mixpanelProjectToken: string;
  spendbrainVersion?: string;
}

const config: Config = {
  apiBaseUrl:
    import.meta.env.VITE_MICROSITES_BASE_API_URL ||
    import.meta.env.VITE_EXTENSION_BASE_API_URL,
  agentApiBaseUrl: import.meta.env.VITE_MICROSITES_AGENT_API_BASE_URL,
  agentIframeBaseUrl: import.meta.env.VITE_AGENT_IFRAME_BASE_URL,
  micrositesOrigin: import.meta.env.VITE_MICROSITES_ORIGIN,
  isExtension: !!import.meta.env.MANIFEST_VERSION,
  spendbrainClientId: import.meta.env.VITE_MICROSITES_CLIENT_ID,
  spendbrainTenantId: import.meta.env.VITE_MICROSITES_TENANT_ID,
  spendbrainSentryDSN: import.meta.env.VITE_MICROSITES_SENTRY_DSN,
  spendbrainEnv: import.meta.env
    .VITE_MICROSITES_ENVIRONMENT as Config['spendbrainEnv'],

  extensionClientId: import.meta.env.VITE_EXTENSION_CLIENT_ID,
  extensionTenantId: import.meta.env.VITE_EXTENSION_TENANT_ID,
  extensionEnv: import.meta.env
    .VITE_EXTENSION_ENVIRONMENT as Config['spendbrainEnv'],
  extensionSentryDSN: import.meta.env.VITE_EXTENSION_SENTRY_DSN,
  extensionGTMId: import.meta.env.VITE_EXTENSION_GTM_ID,
  extensionSecretToken: import.meta.env.VITE_EXTENSION_SECRET_TOKEN,
  mixpanelProjectToken: import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN,
  extensionSpendbrainRedirectUrl: import.meta.env
    .VITE_EXTENSION_SPENDBRAIN_REDIRECT_URL,
  spendbrainVersion: import.meta.env.VITE_SPENDBRAIN_VERSION,
};

export default config;
